import onlyNasFileUploadUseRequest from "@/utils/onlyNasFileUploadUseRequest";

export function chunk(formData) {
  return onlyNasFileUploadUseRequest({
    url: "/api/Upload/Chunk",
    method: "Post",
    data: formData,
    timeout: 5 * 60 * 1000,
  });
}

export function chunk2(formData) {
  return onlyNasFileUploadUseRequest({
    url: "/api/Upload/Chunk2",
    method: "Post",
    data: formData,
    timeout: 5 * 60 * 1000,
  });
}

export function merge(formData) {
  return onlyNasFileUploadUseRequest({
    url: "/api/Upload/Merge",
    method: "Post",
    data: formData,
    timeout: 5 * 60 * 1000,
  });
}

export function merge2(formData) {
  return onlyNasFileUploadUseRequest({
    url: "/api/Upload/Merge2",
    method: "Post",
    data: formData,
    timeout: 5 * 60 * 1000,
  });
}

export function cancel(fileCode, moduleName) {
  return onlyNasFileUploadUseRequest({
    url: `/api/Upload/Cancel?fileCode=${fileCode}&moduleName=${moduleName}`,
    method: "Post",
  });
}
